import React, { useState, useEffect } from 'react';
import {
    Dialog, Typography, Button, Radio, RadioGroup, FormControlLabel,
    TextField, LinearProgress, Box, IconButton, Fade
} from '@mui/material';
import { Close, NavigateNext, ArrowBack, CheckCircleOutline } from '@mui/icons-material';
import { ref, get, push } from "firebase/database";
import { database } from '../adm/admin/firebaseConfig';

export default function PesquisaModal() {
    const [open, setOpen] = useState(false);
    const [survey, setSurvey] = useState(null);
    const [answers, setAnswers] = useState({});
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        const initSurvey = async () => {
            const snap = await get(ref(database, 'pesquisas_satisfacao'));
            if (snap.exists()) {
                const data = snap.val();
                const activeEntry = Object.entries(data).find(([id, s]) => s.active);

                if (activeEntry && !localStorage.getItem(`respondeu_pesquisa_${activeEntry[0]}`)) {
                    setSurvey({ id: activeEntry[0], ...activeEntry[1] });
                    setTimeout(() => setOpen(true), 2000);
                }
            }
        };
        initSurvey();
    }, []);

    const handleSend = async () => {
        if (!survey) return;
        await push(ref(database, `respostas_pesquisas/${survey.id}`), {
            respostas: answers,
            timestamp: Date.now()
        });
        localStorage.setItem(`respondeu_pesquisa_${survey.id}`, 'true');
        setOpen(false);
    };

    const handleIgnore = () => {
        if (!survey) return;
        localStorage.setItem(`respondeu_pesquisa_${survey.id}`, 'true');
        setOpen(false);
    };

    if (!survey) return null;

    const currentQ = survey.questions[currentPage];
    const progress = ((currentPage + 1) / survey.questions.length) * 100;

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            PaperProps={{
                sx: {
                    bgcolor: 'rgba(20, 20, 20, 0.95)',
                    backdropFilter: 'blur(15px)',
                    color: '#fff',
                    borderRadius: 4,
                    width: '450px',
                    border: '1px solid rgba(255,255,255,0.1)'
                }
            }}
        >
            <Box p={3} pb={0} display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="caption" sx={{ color: '#0F71FD', fontWeight: 800, letterSpacing: 1 }}>
                    PASSOS: {currentPage + 1} DE {survey.questions.length}
                </Typography>
                <IconButton onClick={handleIgnore} sx={{ color: '#666' }}><Close /></IconButton>
            </Box>

            <LinearProgress variant="determinate" value={progress} sx={{ mt: 2, bgcolor: '#333', '& .MuiLinearProgress-bar': { bgcolor: '#0F71FD', transition: 'width 0.5s' } }} />

            <Box p={4} minHeight="250px">
                <Fade in={true} key={currentPage}>
                    <Box>
                        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>{currentQ.question}</Typography>

                        {currentQ.type === 'radio' ? (
                            <RadioGroup onChange={(e) => setAnswers({ ...answers, [currentPage]: e.target.value })} value={answers[currentPage] || ''}>
                                {currentQ.options.split(',').map(opt => (
                                    <FormControlLabel key={opt} value={opt} control={<Radio sx={{ color: '#555', '&.Mui-checked': { color: '#0F71FD' } }} />} label={opt} sx={{ mb: 1, bgcolor: 'rgba(255,255,255,0.03)', borderRadius: 2, pl: 1, mr: 0 }} />
                                ))}
                            </RadioGroup>
                        ) : (
                            <TextField
                                fullWidth 
                                multiline 
                                rows={3} 
                                variant="outlined"
                                placeholder="Digite aqui..."
                                value={answers[currentPage] || ''}
                                sx={{ 
                                    '& .MuiOutlinedInput-root': { 
                                        bgcolor: 'rgba(255,255,255,0.08)', 
                                        color: '#fff', 
                                        borderRadius: 2,
                                        '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' },
                                        '&:hover fieldset': { borderColor: '#0F71FD' }
                                    },
                                    '& .MuiInputBase-input::placeholder': { color: '#aaa', opacity: 1 }
                                }}
                                onChange={(e) => setAnswers({ ...answers, [currentPage]: e.target.value })}
                            />
                        )}
                    </Box>
                </Fade>
            </Box>

            <Box p={3} display="flex" flexDirection="column" gap={1}>
                <Box display="flex" gap={2}>
                    {currentPage > 0 && (
                        <Button onClick={() => setCurrentPage(currentPage - 1)} sx={{ color: '#aaa', textTransform: 'none' }} startIcon={<ArrowBack />}>Voltar</Button>
                    )}

                    {currentPage < survey.questions.length - 1 ? (
                        <Button fullWidth variant="contained" onClick={() => setCurrentPage(currentPage + 1)} disabled={!answers[currentPage]} sx={{ bgcolor: '#0F71FD', borderRadius: 2, py: 1.5 }}>
                            Próximo <NavigateNext />
                        </Button>
                    ) : (
                        <Button fullWidth variant="contained" onClick={handleSend} disabled={!answers[currentPage]} sx={{ bgcolor: '#4caf50', borderRadius: 2, py: 1.5 }}>
                            Finalizar <CheckCircleOutline sx={{ ml: 1 }} />
                        </Button>
                    )}
                </Box>

                <Button onClick={handleIgnore} sx={{ color: 'rgba(207, 207, 207, 0.8)', fontSize: '0.75rem', mt: 1, textTransform: 'none', border: '1px solid rgba(255, 4, 4, 0.63)', borderRadius: 2 }}>
                    Não desejo participar, ignorar pesquisa
                </Button>
            </Box>

            <Box textAlign="center" pb={2}>
                <Box sx={{ mt: 'auto', textAlign: 'center', pt: 1.5, borderTop: '1px solid #2d3748' }}>
                    <Typography variant="caption" sx={{ color: '#718096', fontSize: '9px', letterSpacing: 0.8, fontWeight: 700, textTransform: 'uppercase', display: 'block' }}>
                        Desenvolvido por
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#63b3ed', fontWeight: 800, fontSize: '11px', mt: 0.2, letterSpacing: 0.5 }}>
                        BIGSTAR SOFTWARES
                    </Typography>
                </Box>
            </Box>
        </Dialog>
    );
}